export interface DuplicateSection {
  id: string
  name: string
  hint: string
}

// design-system.md's `DuplicateDialog` row says documents.md's own
// List-duplicate use-case "hand-lists all six rows verbatim" as the
// canonical enumeration — but that use-case section isn't present in the
// copy of documents.md this pass was implemented from (only the row-action
// trigger/gate is documented there). The six sections below are this
// package's own placeholder content (plausible OTK document sections, not
// values copied from a source) pending that verbatim list becoming
// available; replace them rather than treating these strings as spec-exact.
export const DUPLICATE_SECTIONS: DuplicateSection[] = [
  {
    id: "vehicle",
    name: "Дані транспортного засобу",
    hint: "Марка, модель, VIN, показник одометра",
  },
  {
    id: "owner",
    name: "Власник",
    hint: "Дані власника транспортного засобу",
  },
  {
    id: "receiver",
    name: "Отримувач",
    hint: "Дані особи, яка отримує документ",
  },
  {
    id: "testResults",
    name: "Результати випробувань",
    hint: "Виміряні показники технічного контролю",
  },
  {
    id: "nonconformities",
    name: "Коди невідповідностей",
    hint: "Виявлені несправності та їх коди",
  },
  {
    id: "photos",
    name: "Фотоматеріали",
    hint: "Фото транспортного засобу",
  },
]

export const DEFAULT_DUPLICATE_SECTIONS: string[] = ["vehicle", "owner", "receiver"]
